export const inputErrorClassNames =
  '!border-nds-accessible-red active:border-nds-accessible-red focus:border-nds-accessible-red focus:ring-nds-accessible-red'

export const inputErrorTextClassNames = '!text-red-800'
